import { styled } from '@mui/material/styles';
import ChipInput from 'components/common/ChipInput';
import { FieldArray } from 'formik';
import { object, string } from 'prop-types';
import React from 'react';

const StyledChipInput = styled(ChipInput)(({ theme }) => ({
  border: `solid 1px ${theme.palette.secondary.light}`,
  borderRadius: '6px',
  padding: '5px',
  paddingBottom: 0,
  '& .WAMuiChipInput-inputRoot': {
    paddingTop: 0,
    border: 0,
    padding: 0,
    '& .WAMuiChipInput-input': {
      padding: '5px',
      paddingBottom: '10px',
      margin: 0,
    },
  },
  '& .WAMuiChipInput-chipContainer': {
    minHeight: 'initial',
    marginBottom: 0,
    alignItems: 'center',
    padding: 0,
  },
  '& .WAMuiChipInput-chip': {
    height: '26px',
    marginTop: 0,
    marginBottom: '5px',
    '& svg': {
      marginRight: '2px',
    },
  },
}));

const FormikChipInput = ({ field, form, className = null, ...props }) => {
  const { name, onBlur } = field;
  const { errors, submitCount, getFieldProps } = form;
  const { value } = getFieldProps(name);
  return (
    <FieldArray
      name={name}
      render={arrayHelpers => (
        <StyledChipInput
          className={className}
          disableUnderline
          fullWidth
          {...props}
          onAdd={chip => arrayHelpers.push(chip)}
          onDelete={(chip, index) => arrayHelpers.remove(index)}
          onBlur={onBlur}
          value={value}
          name={name}
          error={!!(errors[name] && submitCount > 0)}
          helperText={submitCount > 0 && errors[name]}
        />
      )}
    />
  );
};

FormikChipInput.propTypes = {
  field: object.isRequired,
  form: object.isRequired,
  className: string,
};

export default FormikChipInput;
